import React from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";
import { bool } from "prop-types";

const TitleColumns = ({ hasBills }) => (
    <>
        <GridTable.Data columnStart={1} rowStart={1} rowWidth={1}>
            <I18n component="span" id="creditBill.table.emitter" />
        </GridTable.Data>
        <GridTable.Data columnStart={2} rowStart={1} rowWidth={1}>
            <I18n component="span" id="creditBill.table.debtor" />
        </GridTable.Data>
        <GridTable.Data columnStart={3} rowStart={1} rowWidth={1}>
            <I18n component="span" id="creditBill.table.emission" />
        </GridTable.Data>
        <GridTable.Data columnStart={4} rowStart={1} rowWidth={1}>
            <I18n component="span" id="creditBill.table.expiration" />
        </GridTable.Data>
        <GridTable.Data columnStart={5} rowStart={1} rowWidth={1}>
            <I18n component="span" id="creditBill.table.amount" />
        </GridTable.Data>
        <GridTable.Data columnStart={6} rowStart={1} rowWidth={1}>
            <I18n component="span" id="creditBill.table.state" />
        </GridTable.Data>
        <GridTable.Data columnStart={7} rowStart={1} rowWidth={1}>
            <I18n component="span" id="creditBill.table.registeredCbu" />
        </GridTable.Data>
        {hasBills && <GridTable.Data columnStart={8} rowStart={1} rowWidth={1} />}
    </>
);
TitleColumns.propTypes = {
    hasBills: bool,
};
TitleColumns.defaultProps = {
    hasBills: false,
};
export default TitleColumns;
